import { SELECT_BOUND } from './types';

export const selectBoundAction = selectedBound => ({
  type: SELECT_BOUND,
  selectedBound,
});
